export class WebServices {
  static getServerTimestamp = () => {
    const url = 'https://getservertimestamp-x3herayjcq-uc.a.run.app';
    return fetch(url, { method: 'GET', mode: 'cors', cache: 'no-cache' })
      .then(response => this.onResponse(response))
      .then(response => {
        return response.timestamp;
      })
      .catch(() => {
        return undefined;
      });
  };

  static onResponse = (response, parseErrors = false) => {
    if (response.ok || parseErrors) {
      try {
        return response.json();
      } catch (error) {
        console.error(`Unable to parse JSON response for endpoint ${response.url}`);
        return undefined;
      }
    } else {
      return undefined;
    }
  };
}